import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-info-tooltip',
    templateUrl: './info-tooltip.component.html',
    styleUrls: ['./info-tooltip.component.scss'],
})
export class InfoTooltipComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
